<template>
    <b-modal
        id="changeDueDate"
        title="Editar Próximo Vencimento"
        centered
        hide-footer
    >
        <b-overlay :show="loading" rounded="sm">

            <!-- Field -->
            <b-form-group
                label="Qual a data do próximo vencimento deste professor ?">

                <b-form-datepicker v-model="form.due_date" locale="pt"></b-form-datepicker>

            </b-form-group>

            <b-form-group>
                <b-button type="button" variant="primary" @click="update" :disabled="loading">
                    Editar Data
                </b-button>
            </b-form-group>
        </b-overlay>
    </b-modal>
</template>

<script>
export default {
    props: [],
    data() {
        return {
            loading: false,
            id: null,
            form: {
                due_date: null,
            },
        }
    },
    created() {

        this.$root.$on('changeDueDate', (teacher) => {

            this.id = teacher.id
            this.form.due_date = teacher.due_date

            this.$bvModal.show('changeDueDate')
        })

    },
    methods: {

        update() {
            this.loading = true;
            axios.put('/admin/teachers/' + this.id + '/due-date', this.form)
                .then((result) => {

                    // Load
                    this.$emit('updated')

                    // Message
                    this.$toast.success('Data de vencimento alterada com sucesso :)');

                    // Close Modal
                    this.$bvModal.hide('changeDueDate')

                })
                .finally(() => this.loading = false)
        },
    }
}
</script>

<style scoped>

</style>
